import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, UntypedFormBuilder, ValidationErrors } from '@angular/forms';
import { FunctionsService } from "../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../api.service';
import { Router } from '@angular/router';
import { AppConstants } from '../../app.constants';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ChangePlanComponent } from './change-plan/change-plan.component';
import { StripeService, StripeCardComponent, Element as StripeElement, ElementOptions, ElementsOptions } from "@nomadreservations/ngx-stripe";
import { NgxSpinnerService } from 'ngx-spinner';
import { PaymentProcessedComponent } from './payment-processed/payment-processed.component';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html'
})

export class AccountComponent implements OnInit {
    @ViewChild(StripeCardComponent) card: StripeCardComponent;
    stripeKey = '';
    error = {message:""};
    complete = false;
    element: StripeElement;
    model = { options: 'M' };
    cardOptions: ElementOptions = {
        style: {
        base: {
            iconColor: '#276fd3',
            color: '#31325F',
            lineHeight: '40px',
            fontWeight: 300,
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSize: '18px',
            '::placeholder': {
            color: '#CFD7E0'
            }
        },
        invalid: {
            color: '#C12127',
            iconColor: '#C12127'
        }
        }
    };

    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

    elementsOptions: ElementsOptions = {
        locale: localStorage.getItem('language')=="es"?'es':'en'
    };

    token:string;
    formSubmitted: boolean = false;
    cart:any;
    userId:any;
    tax:any;
    subtotal:any;
    total:any;
    MorY:any;
    disableBtn = false;
    orgProfile:any;
    email:any;
    modalOptions: NgbModalOptions = {};
    withinPR:boolean = false;
    stripe;
    cardErrors;
  
    loading = false;
    confirmation;

    submitted = false;
    formProcess = false;
    message = "";

    constructor(private apiService: ApiService,
        private formBuilder: UntypedFormBuilder,
        public functionsService:FunctionsService, 
        public router: Router, 
        private modalService: NgbModal,
        private translate: TranslateService,
        private _stripe: StripeService,
        private spinner: NgxSpinnerService,
        private breadcrumbService: BreadcrumbService){
            translate.setDefaultLang('en');
            this.functionsService.setTitle('account.account');
        }
         

    buySubscriptionForm = this.formBuilder.group({
        CardName: ['', [Validators.required, Validators.maxLength(26), Validators.pattern(AppConstants.cardNameRegex)]],
        BillingAddress: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(AppConstants.addressRegex)]],
        BillingCity: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingState: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingCountry: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(AppConstants.addressRegex)]],
        BillingCycle: [],
    });

    customStripeForm = this.formBuilder.group({
        cardNumber: [],
        cvv: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(AppConstants.numberRegex)]],
        expMonth: ['', [Validators.required, Validators.maxLength(2), Validators.pattern(AppConstants.monthRegex)]],
        expYear: ['', [Validators.required, Validators.maxLength(4), Validators.pattern(AppConstants.numberRegex)]]
    });

    ngOnInit(){
        this.getCartItem();
        this.translate.onLangChange.subscribe(() => {
            if(this.error){
                this.error["message"] = "";
            }
            this.elementsOptions = {
                locale: (localStorage.getItem('language')=='es')?'es':'en'
            };
        });

        //this.breadcrumbService.set

        this.buySubscriptionForm.valueChanges 
            .subscribe(() => {
                 this.disableBtn = this.buySubscriptionForm.valid;
            });
    }
    
    getCartItem(){
        this.spinner.show();
        this.apiService.getCart().subscribe(
            data => {
                if(data!=null){
                    this.cart = data;
                    this.MorY = this.MorY?this.MorY:"monthly";
                    this.model = { options: this.MorY=="yearly"?'Y':'M' };
                    this.getBillingQuantity(this.model.options);
                    //if(document.getElementById("tax-row")){document.getElementById("tax-row").style.display = 'flex'};
                    //if(document.getElementById("tax-row")){document.getElementById("tax-row").style.display = 'none'};
                }
                else { //Get organization/profile info
                    this.apiService.getOrganizationProfile().subscribe(
                        data => {
                            this.orgProfile = data;
                            this.email = this.functionsService.getEmail();
                        }
                    );
                }
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        )
    }

    buySubscription(){
        if (!this.buySubscriptionForm.valid) {
            Object.keys(this.buySubscriptionForm.controls).forEach(key => {
              const controlErrors: ValidationErrors = this.buySubscriptionForm.get(key).errors;
              if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                  console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
              }
            });
            this.formSubmitted = true;
            return;
        } 
        
        this.spinner.show();
        this._stripe
            .createToken(this.card.getCard(), { 
                name: this.buySubscriptionForm.value["CardName"], 
                address_line1: this.buySubscriptionForm.value["BillingAddress"],
                address_city: this.buySubscriptionForm.value["BillingCity"],
                address_state: this.buySubscriptionForm.value["BillingState"],
                address_country: this.buySubscriptionForm.value["BillingCountry"],
                currency: "USD"
            })
            .subscribe(result => {
                if (result.token)
                {
                    //Create body content
                    var content:Object = {};
                    content["Tax1"] = this.withinPR?this.tax:0;
                    content["Price"] = this.subtotal;
                    content["Total"] = this.total;
                    content["Result"] = result.token;
                    content["PlanId"] = this.cart.planId;
                    content["Cycle"] = this.buySubscriptionForm.value["BillingCycle"];
                    content["Language"] = this.language.toUpperCase();
                    
                    this.apiService.registerTrial(content).subscribe(
                        () => {
                            var language = localStorage.getItem("language");
                            window.localStorage.clear();
                            this.modalOptions.backdrop = 'static';
                            this.modalOptions.keyboard = false;
                            this.modalOptions.size = 'lg';
                            localStorage.setItem('language', language);
                            this.modalService.open(PaymentProcessedComponent, this.modalOptions);
                            this.functionsService.userSignOut();
                            this.spinner.hide(); 
                            
                        }, 
                        error => {
                            this.spinner.hide(); 
                            if(error["error"]["content"])
                            {
                                var index = error["error"]["content"].indexOf("stripe:");
                                if(index !== -1){  
                                    //Stripe error
                                    var stripeError = error["error"]["content"].split(":");
                                    const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                                    modalRef.componentInstance.title = this.translate.instant('stripe.payment_error');
                                    modalRef.componentInstance.message = this.translate.instant('stripe.' + stripeError[1]);
                                    this.translate.onLangChange.subscribe(() => {
                                        modalRef.componentInstance.title = this.translate.instant('stripe.payment_error');
                                        modalRef.componentInstance.message = this.translate.instant('stripe.' + stripeError[1]);
                                    });
                                    return;
                                }
                                else if(error["error"]["content"]=="exception:subscription_exists"){
                                    const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                                    modalRef.componentInstance.title = this.translate.instant('stripe.payment_error');
                                    modalRef.componentInstance.message = this.translate.instant("subscription_exists");
                                    this.translate.onLangChange.subscribe(() => {
                                        modalRef.componentInstance.title = this.translate.instant('stripe.payment_error');
                                        modalRef.componentInstance.message = this.translate.instant("subscription_exists");
                                    });
                                    return;
                                }
                            }
                            this.functionsService.errorHandler(error["status"]);
                        }
                    )
                } else if (result.error) {
                    // Error creating the token
                    const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                    modalRef.componentInstance.title = this.translate.instant('stripe.payment_error');
                    modalRef.componentInstance.message = result.error.message;
                    this.spinner.hide();
                }
            });
    }

    changePlan(d) {
        this.spinner.show();
        //Get list of available plans
        this.apiService.getPlans().subscribe(
            data => {
                //Pass current selected plan (if any)
                const modalRef = this.modalService.open(ChangePlanComponent, { size: 'xl' });
                if(this.cart == undefined){
                    modalRef.componentInstance.selectedPlan = 0;
                }
                else{
                    modalRef.componentInstance.selectedPlan = this.cart.planId;
                }
                modalRef.componentInstance.title = d;
                modalRef.componentInstance.plans = data;
                modalRef.result.then(() => {
                    this.getCartItem();
                });
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    getBillingQuantity(type){
        if(type=='Y'){
            this.subtotal = this.cart.planAnnualPrice;
            this.tax = (this.cart.planAnnualPrice * 11.5) / 100;
            this.total = this.withinPR?(this.subtotal + this.tax):this.subtotal;
            this.MorY = "yearly"
        }else{ //Montly is the default
            this.subtotal = this.cart.planMonthlyPrice;
            this.tax = (this.cart.planMonthlyPrice * 11.5) / 100;
            this.total = this.withinPR?(this.subtotal + this.tax):this.subtotal;
            this.MorY = "monthly"
        }
    }

    get CardName() { return this.controlGetter('CardName'); }
    get BillingAddress() { return this.controlGetter('BillingAddress'); }
    get BillingCity() { return this.controlGetter('BillingCity'); }
    get BillingState() { return this.controlGetter('BillingState'); }
    get BillingCountry() { return this.controlGetter('BillingCountry'); }
    get BillingCycle() { return this.controlGetter('BillingCycle'); }

    controlGetter(controlName) {
        const control =  this.buySubscriptionForm.get(controlName);
        return control && (control.touched || this.formSubmitted) ? control : {};
    }

    cardUpdated(result) {
        var zipCode = +result.card.value.postalCode;
        (<HTMLInputElement>document.getElementById("BillingZipCode")).value = result.card.value.postalCode;
        this.withinPR = this.functionsService.checkZipCode(zipCode);
        if(this.withinPR){ //Show tax
            this.total = this.subtotal + this.tax;
            document.getElementById("tax-row").style.display = 'flex';
        }
        else{
            this.total = this.subtotal;
            document.getElementById("tax-row").style.display = 'none';
        }
        this.element = result.element;
        this.complete = result.card.complete;
        this.error = undefined;
    }
    
    keyUpdated() {
        this._stripe.changeKey(this.stripeKey);
    }

    backToAccount() {
        
        this.apiService.getOrganizationProfile().subscribe(
            
            data => {
                this.orgProfile = data;
                this.email = this.functionsService.getEmail();
            },

            error => {
                this.functionsService.errorHandler(error["status"]);
            }

            
        );
        this.cart = null;
        

    }
}